/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import React from 'react';
import { DashboardSection } from '../dashboard';
import { SurveyRange } from '../../types/custom-report';
import CustomReportEditFormDate from './CustomReportEditFormDate';
import './styles.scss';

interface CustomReportManageDateProps {
  customReport?: SurveyRange;
  handleReload: () => Promise<void>;
}

const CustomReportManageDate = (props: CustomReportManageDateProps) => {
  const { customReport, handleReload } = props;

  return (
    <>
      <DashboardSection title={'Date comparison report builder'}>
        <div className='mt-4'>
          <CustomReportEditFormDate
            customReport={customReport}
            handleReload={handleReload}
          />
        </div>
      </DashboardSection>
    </>
  );
};

export default CustomReportManageDate;
